import { NgModule } from '@angular/core';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { BaseModule } from '../../shared/base.module';
import { TherapyOffersComponent } from './therapy-offers.component';
import { MATERIALS } from '../../app.materials';
import { NgSelect2Module } from 'ng-select2';
import { TinymceModule } from 'angular2-tinymce';
import { ModalModule } from 'ngx-bootstrap/modal';


@NgModule({
    imports: [
        MATERIALS,
        BaseModule,
        NgSelect2Module,
        TooltipModule.forRoot(),
        TinymceModule.withConfig({
            menubar: false,
            elementpath: false,
            toolbar: 'bold italic alignleft numlist bullist link formatselect'
        }),
        ModalModule.forRoot(),
    ],
    exports: [TherapyOffersComponent],
    declarations: [TherapyOffersComponent],
    providers: [],
})

export class TherapyOffersModule {
}
